import { HERO_WITH_RICH_TEXT_CONTENT } from './data'

export function getStaticProps() {
  return {
    props: {
      layoutProps: {
        heroProps: HERO_WITH_RICH_TEXT_CONTENT,
        showBorderRadius: false,
      },
    },
    revalidate: 300,
  }
}
